import React, {useEffect, useState} from 'react';
import Modal from "../UI/Modal";
import {useTypedSelector} from "../../hooks/useTypedSelector";
import {OrderItemType} from "../../models/OrderModels";

const AddItem = (props) => {
    const [Step, SetStep] = useState(1)

    const EmptyItem = {
        order_id: props.orderId,
        desired_at: props.orderDesiredAt,

        model: 39,
        waist: null,
        width: null,
        thread_color: 21,
        top_design: null,
        top_material: 9,
        top_color: 21,
        bottom_design: 'Не определено',
        bottom_color: 21,
        lining_material: 9,
        lining_color: 21,

        comment: null,
        group: null,
        groupId: null,
    }

    const [Item, SetItem] = useState(EmptyItem)

    const ig = useTypedSelector(state => state.item_groups)
    const it = useTypedSelector(state => state.item_types)
    const im = useTypedSelector(state => state.itemRefs)

    async function AddItem() {
        props.AddItemF(Item)
        SetItem(EmptyItem)
        SetStep(1)
    }

    return (
        <div>
            <Modal id="add_item" title="Добавить изделие"  onClose={() => {
                SetItem(EmptyItem)
                SetStep(1)
                props.closeModal()
            }}
            footerButtons={Step === 2?<button className="btn bg-gradient-success" onClick={AddItem}>Сохранить</button>:''}
            show={props.modal} addClass="modal-lg">
                <h4>Шаг <span>{Step}</span>/2</h4>
                {Step === 1 &&
                    <div className="row service_list">
                        {ig.item_groups.map((el) =>
                            <div className="col-lg-4 col-md-6 mb-4" key={el.id}>
                                <div className="card serviceCard h-100" onClick={() => {
                                    SetItem({...Item, group: el.name, groupId: el.id})
                                    SetStep(2)
                                }} style={{backgroundImage: 'linear-gradient(310deg, rgb(43, 42, 41), rgb(102, 102, 102))', color: 'rgb(204, 204, 204)'}}>
                                    <div className="card-body p-3"><h6 style={{color: 'rgb(255, 255, 255)'}}>{el.name}</h6></div>
                                </div>
                            </div>
                        )}
                    </div>
                }
                {Step === 2 &&
                    <div className="row service_list" style={{display: 'grid', gridTemplateColumns: '50% 50%'}}>

                        {Item.groupId === '2' &&
                        <div className="form-group">
                            <label>Обхват талии</label>
                            <input type="text" value={Item.waist} onChange={(e) => SetItem({...Item, waist: e.target.value})} className="form-control"/>
                        </div>
                        }
                        {Item.groupId === '2' &&
                        <div className="form-group">
                            <label>Ширина ремня</label>
                            <input type="text" value={Item.width} onChange={(e) => SetItem({...Item, width: e.target.value})} className="form-control"/>
                        </div>
                        }
                        {Item.groupId === '2' &&
                        <div className="form-group">
                            <label>Цвет пряжки</label>
                            <select value={Item.thread_color} onChange={(e) => SetItem({...Item, thread_color: e.target.value})} className="form-control">
                                {im.color.filter((el) => {
                                    return el.id == 21 || el.id == 12 || el.id == 13
                                }).map((el) =>
                                    <option key={el.id} value={el.id}>{el.name}</option>
                                )}
                            </select>
                        </div>
                        }
                        {Item.groupId === '1' &&
                        <div className="form-group">
                            <label>Модель</label>
                            <select value={Item.model} onChange={(e) => SetItem({...Item, model: e.target.value})}
                                    className="form-control">
                                {it.item_types[Item.groupId].map((el) =>
                                    <option key={el.id} value={el.id}>{el.name}</option>
                                )}
                            </select>
                        </div>
                        }
                        {Item.groupId === '1' &&
                        <div className="form-group">
                            <label>Вид конструкции верха</label>
                            <input type="text" value={Item.top_design} onChange={(e) => SetItem({...Item, top_design: e.target.value})} className="form-control"/>
                        </div>
                        }
                        <div className="form-group">
                            <label>Вид материала верха</label>
                            <select value={Item.top_material} onChange={(e) => SetItem({...Item, top_material: e.target.value})} className="form-control">
                                {im.materials.map((el) =>
                                    <option key={el.id} value={el.id}>{el.name}</option>
                                )}
                            </select>
                        </div>
                        <div className="form-group">
                            <label>Цвет конструкции верха</label>
                            <select value={Item.top_color} onChange={(e) => SetItem({...Item, top_color: e.target.value})} className="form-control">
                                {im.color.map((el) =>
                                    <option key={el.id} value={el.id}>{el.name}</option>
                                )}
                            </select>
                        </div>
                        {Item.groupId === '1' &&
                        <div className="form-group">
                            <label>Вид конструкции низа</label>
                            <select value={Item.bottom_design} onChange={(e) => SetItem({...Item, bottom_design: e.target.value})} className="form-control">
                                <option>Не определено</option>
                                <option>Кожа</option>
                                <option>EVA</option>
                                <option>Формованная</option>
                            </select>
                        </div>
                        }
                        {Item.groupId === '1' &&
                        <div className="form-group">
                            <label>Цвет конструкции низа</label>
                            <select value={Item.bottom_color} onChange={(e) => SetItem({...Item, bottom_color: e.target.value})} className="form-control">
                                {im.color.map((el) =>
                                    <option key={el.id} value={el.id}>{el.name}</option>
                                )}
                            </select>
                        </div>
                        }

                        {Item.groupId !== '2' &&
                        <div className="form-group">
                            <label>Материал подкладки</label>
                            <select value={Item.lining_material} onChange={(e) => SetItem({...Item, lining_material: e.target.value})} className="form-control">
                                {im.materials.map((el) =>
                                    <option key={el.id} value={el.id}>{el.name}</option>
                                )}
                            </select>
                        </div>
                        }
                        <div className="form-group">
                            <label>Цвет подклада</label>
                            <select value={Item.lining_color} onChange={(e) => SetItem({...Item, lining_color: e.target.value})} className="form-control">
                                {im.color.map((el) =>
                                    <option key={el.id} value={el.id}>{el.name}</option>
                                )}
                            </select>
                        </div>
                        {Item.groupId !== '2' &&
                        <div className="form-group">
                            <label>Образец от заказчика</label>
                            <form action="/file-upload" className="form-control">
                                <input name="file" type="file" multiple/>
                            </form>
                        </div>
                        }
                        <div className="form-group">
                            <label>Примечание</label>
                            <input type="text" value={Item.comment} onChange={(e) => SetItem({...Item, comment: e.target.value})} className="form-control"/>
                        </div>
                    </div>
                }
            </Modal>
        </div>
    );
};

export default AddItem;